function Beta() {
  return (
    <>
      <div className="betaHeader">
        <h2>early access beta program overview</h2>
      </div>

      <div class="row">


      <div className="betaProgramParagraph">
        <p className="column">
          We’re currently testing a <strong>lightweight version</strong> of purepostage with a small group of early partners.  
          
          <br></br>
          <br></br>
          <strong>Here’s how it works:</strong><br />
          • You’ll submit basic order info using our intake form.<br />
          • We’ll generate and send you a digital shipping label.<br />
          • You’ll receive a summary with sustainability data (emissions summary).
        </p>


        <p className="column">
          Your feedback will help shape the future of purepostage.  
          <br /><br />
                    <br /><br />
          Interested? Get your business on the waitlist by heading over to the{" "}
           <a href="/waitlist">waitlist page</a> !
        </p>
      </div>
      </div>
    </>
  );
}

export default Beta;
